import { useEffect } from "react";
import Breadcrumb from "../breacrumb/breadcrumb";
import icon1 from "../../../asset/image/new/nat2-1.svg";
import icon2 from "../../../asset/image/new/nat2-2.svg";
import icon3 from "../../../asset/image/new/nat2-3.svg";
import TestingSteps from "../../../asset/image/new/hla-b-58-group.png";

function NAT2() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ข้อมูลที่เกี่ยวข้อง", url: "/information" },
    { name: "เภสัชพันธุศาสตร์", url: "/information/pharmacogeneticTest" },
    { name: "NAT2", url: "/information/pharmacogeneticTest/NAT2" },
  ];

  const Nat2 = [
    {
      url: `${icon1}`,
      name: "NAT2",
      title:
        "การตรวจ NAT2-Diplotype ตรวจยีนย่อยสลายยา Isoniacid เพื่อพิจารณาให้ยาในขนาดที่เหมาะสม",
    },
    {
      url: `${icon2}`,
      name: "ความเสี่ยงต่อภาวะตับอักเสบ",
      title: "ภาวะตับอักเสบในการใช้ยาต้านวัณโรค ในกลุ่มผู้ย่อยยา Slow acetylator การตอบสนองยาได้ช้า",
    },
    {
      url: `${icon3}`,
      name: "การย่อยสลายยา",
      title: "ลักษณะการตอบสนองต่อยาของ 3 กลุ่มผู้ย่อยยา Slow acetylator กำจัดยาได้ช้า เสี่ยงต่อพิษจากยา โดยเฉพาะตับอักเสบจากยา Intermediate acetylator ระดับกลาง ความเสี่ยงปานกลาง Rapid acetylator กำจัดยาได้เร็ว เสี่ยงที่ยาออกฤทธิ์ไม่เพียงพอ",
    },
    {
      url: `${icon3}`,
      name: "รูปแบบการย่อยสลายยา",
      title:
        "ยา Isoniacid จะถูกย่อยผ่านเอมไซม์ N-Acetyltransferase2 (NAT2) เป็นยีนที่มีความหลากหลายทางพันธุกรรมสูง (highgenetic diversity) โดยลักษณะทางพันธุกรรม ทำให้แต่ละบุคคลมีลักษณะการทำงานของ NAT2 ที่เฉพาะในแต่ละบุคคล",
    },
  ];
  return (
    <div className="global-page">
      <Breadcrumb pathItems={pathItems} />
      <div className="2lg:grid-cols-1 grid grid-flow-dense grid-cols-1 w-full gap-5 py-8 mt-6">
        {Nat2.map((hla, index) => (
          <div
            key={index}
            className="sm:flex-col sm:items-center flex flex-row gap-4"
          >
            <div className="xl:max-h-36 overflow-hidden min-w-36 w-[15%] aspect-square p-5 justify-items-center align-middle bg-white rounded-lg border border-gray-400">
              <img className="object-scale-down h-full" src={hla.url} alt={`รูปประกอบ ${hla.name}`}/>
            </div>
            <div className="flex flex-col gap-1 w-[80%] py-2">
              <span className="text-xl font-bold">{hla.name}</span>
              <span>{hla.title}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="text-xl font-bold py-4">
        ขั้นตอนการตรวจยีน NAT2
      </div>
      <div className="sm:px-2 sm:py-0 w-full aspect-[5/2] px-10 py-5 rounded-xl border border-gray-400">
        <img className="object-contain h-full" src={TestingSteps} alt={`รูปขั้นตอนการตรวจยีน NAT2`}/>
      </div>
    </div>
  );
}
export default NAT2;
